// extracted by mini-css-extract-plugin
export var content = "InitialSignUpScreen-module__content___hZxjr";
export var divider = "InitialSignUpScreen-module__divider___G8YwO";
export var create = "InitialSignUpScreen-module__create___UfRE5";
export var signUpLogInContainer = "InitialSignUpScreen-module__signUpLogInContainer___Lytfu";
export var inline = "InitialSignUpScreen-module__inline___OSSie";